import React, { Component } from "react";
import styles from "./cmsReprocessUnitsPanel.module.scss";
import { withReprocessUnits } from "../../../shared/containers/containerReprocessUnits";
import FormItem from "../../../shared/items/static/formItem";
import FormItemsInline from "../../../shared/items/static/formItemsInline";
import InputDate from "../../../shared/items/contols/inputDate";
import InputTime from "../../../shared/items/contols/inputTime";
import Select from "react-select";
import { states } from "../../../reducers/queriesStates";
import getDates from "../../../shared/services/date.service";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import { TextField } from "@mui/material";
import Preloader from "../../../shared/items/static/preloader";

const _reprocessTypes = [
  /*   {
    value: 0,
    label: "Полная обработка",
  },
  {
    value: 1,
    label: "Обработка геозон",
  },
  {
    value: 2,
    label: "Обработка топлива",
  }, */
];

class CmsReprocessUnitPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDisabled: false,
      reprocessType: _reprocessTypes[0],
      comment: null,
      valueStore: {
        reprocessUnitDate: new Date(),
        reprocessUnitTime: new Date(),
        reprocessUnitEndDate: new Date(),
        reprocessUnitEndTime: new Date(),
      },
    };
  }

  CheckDisabled() {
    const { isDisabled } = this.state;
    const { reprocessUnits, unit } = this.props;

    const reprocessUnit = reprocessUnits.filter((x) => {
      return x.unitInfo.unitId === unit.id;
    })[0];

    if (!isDisabled && reprocessUnit !== undefined) {
      const state = {
        isDisabled: true,
        reprocessType: _reprocessTypes.filter((x) => {
          return x.value === reprocessUnit.reprocessType;
        })[0],

        valueStore: {
          reprocessUnitDate: reprocessUnit.startDate,
          reprocessUnitTime: reprocessUnit.startDate,
          reprocessUnitEndDate: reprocessUnit.endDate,
          reprocessUnitEndTime: reprocessUnit.endDate,
        },
      };

      this.setState(state);
    }
  }

  componentDidMount() {
    const { reprocessUnitsDataState, onGetReprocessUnits, reprocessTypesDataState, onGetReprocessTypes } = this.props;

    if (reprocessTypesDataState === states.NOT_REQUESTED) {
      onGetReprocessTypes();
    }

    if (reprocessUnitsDataState === states.NOT_REQUESTED) {
      onGetReprocessUnits();
    }

    this.CheckDisabled();
  }

  componentDidUpdate(prevProps) {
    const { createReprocessUnitsDataState, reprocessUnitsDataState, reprocessTypesDataState, reprocessTypes } = this.props;

    if (prevProps.reprocessTypesDataState === states.REQUEST && reprocessTypesDataState === states.READY) {
      if (_reprocessTypes.length === 0) {
        Object.keys(reprocessTypes).forEach((x) => {
          _reprocessTypes.push({ value: parseInt(x), label: reprocessTypes[x] });
        });
      }

      this.setState({ reprocessType: _reprocessTypes[0] });
    }

    if (prevProps.reprocessUnitsDataState === states.REQUEST && reprocessUnitsDataState === states.READY) {
      this.CheckDisabled();
    }

    if (prevProps.createReprocessUnitsDataState === states.REQUEST && createReprocessUnitsDataState === states.READY) {
      this.CheckDisabled();
    }
  }

  onHandleChangeStore(name, value) {
    const { valueStore } = this.state;
    valueStore[name] = value;

    this.setState({ valueStore });
  }

  onSelectReprocessType(reprocessType) {
    this.setState({ reprocessType });
  }

  onCreateButtonClick() {
    const { unit, onCreateReprocessUnit } = this.props;
    const { valueStore, reprocessType, comment } = this.state;

    const options = {
      unitId: unit.id,
      startDate: getDates.concat(valueStore.reprocessUnitDate, valueStore.reprocessUnitTime),
      endDate: getDates.concat(valueStore.reprocessUnitEndDate, valueStore.reprocessUnitEndTime),
      reprocessType: reprocessType.value,
      comment: comment,
    };

    onCreateReprocessUnit(options);
  }

  render() {
    const { unit, reprocessUnitsDataState, reprocessTypesDataState, reprocessUnits } = this.props;

    if (reprocessTypesDataState !== states.READY) {
      return null;
    }

    if (unit === null || reprocessUnitsDataState !== states.READY) {
      return null;
    }

    const reprocessUnit = reprocessUnits.filter((x) => {
      return x.unitInfo.unitId === unit.id;
    })[0];

    if (reprocessUnit !== undefined) {
      return (
        <div className={styles.cmsReprocessUnitPanelContainer}>
          <div style={{ fontWeight: 600, fontSize: 16 }}>Задача на обработку уже создана</div>
        </div>
      );
    }

    const { valueStore, isDisabled, reprocessType, comment } = this.state;

    if (reprocessType === undefined || reprocessType === null) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    return (
      <div className={styles.cmsReprocessUnitPanelContainer}>
        <FormItemsInline>
          <FormItem title="Дата начала">
            <InputDate
              disabled={isDisabled}
              name="reprocessUnitDate"
              onHandleChangeStore={this.onHandleChangeStore.bind(this, "reprocessUnitDate")}
              valueStore={valueStore}
              maxDate={new Date()}
            />
          </FormItem>

          <FormItem title="Время начала">
            <InputTime
              disabled={isDisabled}
              name="reprocessUnitTime"
              onHandleChangeStore={this.onHandleChangeStore.bind(this, "reprocessUnitTime")}
              valueStore={valueStore}
            />
          </FormItem>

           <FormItem title="Дата конца">
            <InputDate
              disabled={isDisabled}
              name="reprocessUnitEndDate"
              onHandleChangeStore={this.onHandleChangeStore.bind(this, "reprocessUnitEndDate")}
              valueStore={valueStore}
              maxDate={new Date()}
            />
          </FormItem>

          <FormItem title="Время конца">
            <InputTime
              disabled={isDisabled}
              name="reprocessUnitEndTime"
              onHandleChangeStore={this.onHandleChangeStore.bind(this, "reprocessUnitEndTime")}
              valueStore={valueStore}
            />
          </FormItem>

          <FormItem title="Тип обработки">
            <Select
              key={reprocessType.value}
              className={styles.basicSingle}
              classNamePrefix="select"
              value={reprocessType}
              isDisabled={isDisabled}
              isLoading={false}
              isClearable={false}
              isRtl={false}
              isSearchable={false}
              name="reprocessType"
              options={_reprocessTypes}
              onChange={this.onSelectReprocessType.bind(this)}
            />
          </FormItem>

          <FormItem title={"Создать"}>
            <ButtonPrimary
              disabled={comment === null || comment === "" || isDisabled}
              title={"Начать обработку"}
              handleClick={this.onCreateButtonClick.bind(this)}
            ></ButtonPrimary>
          </FormItem>
        </FormItemsInline>

        <FormItemsInline>
          <TextField
            style={{ width: 600 }}
            id="outlined-basic"
            label="Комментарий"
            variant="outlined"
            multiline
            rows={6}
            fullWidth
            disabled={isDisabled}
            onChange={(e) => {
              this.setState({ comment: e.target.value });
            }}
          />
        </FormItemsInline>
      </div>
    );
  }
}

export default withReprocessUnits(React.memo(CmsReprocessUnitPanel));
